module.exports = __webpack_public_path__ + "img/统计中心.5c3d6032.png";